module.exports = __webpack_public_path__ + "img/enterprises2.32fecbbc.png";